module.exports = __webpack_public_path__ + "img/paper-bag-2.166d190d.png";